import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { VigenciaTarifa } from '../../components'
import * as vigenciaTarifaActionCreators from '../../redux/modules/vigenciaTarifa'
import * as subgrupoActionCreators from '../../redux/modules/subgrupo'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'

class VigenciaTarifaContainer extends Component {

  static propTypes = {
    concessionaria: PropTypes.object.isRequired,
    history: PropTypes.object,
    multipleVigenciaTarifa: PropTypes.object,
    fetchMultipleVigenciaTarifa: PropTypes.func,
    destroyVigenciaTarifa: PropTypes.func,
    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
    isLoading: PropTypes.bool,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string,
    multipleSubgrupo: PropTypes.object,
    fetchMultipleSubgrupo: PropTypes.func,
  }

  async componentDidMount () {
    const { concessionaria } = this.props
    await Promise.all([
      this.props.fetchMultipleVigenciaTarifa(concessionaria.id),
      this.props.fetchMultipleSubgrupo(),
    ])
  }

  handleRedirectToNew = (concessionariaId) => {
    this.props.history.push(`/concessionarias/${concessionariaId}/tarifas/new`)
  }

  handleEditResource = (concessionariaId, id) => {
    this.props.history.push(`/concessionarias/${concessionariaId}/tarifas/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyVigenciaTarifa(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('vigenciaTarifa', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('vigenciaTarifa', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleVigenciaTarifa.toList().toJSON(),
      'vigenciaTarifa',
      [
        'id'
      ]
    )
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <VigenciaTarifa
        concessionaria={this.props.concessionaria}
        onRedirectToNew={() => this.handleRedirectToNew(this.props.concessionaria.id)}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        multipleVigenciaTarifa={this.props.multipleVigenciaTarifa}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading}
        multipleSubgrupo={this.props.multipleSubgrupo}
      />
    )
  }
}

function mapStateToProps ({vigenciaTarifa, subgrupo, status, sort, filter}, {concessionaria}) {
  const sortColumn = sort.getIn(['vigenciaTarifa', 'sortColumn']) || 'nome'
  const sortDirection = sort.getIn(['vigenciaTarifa', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['vigenciaTarifa', 'filterText']) || ''

  let map = filterMap(vigenciaTarifa, ['starts_at', 'bandeira.nome'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleVigenciaTarifa: map.filter(t => t.get('concessionaria_id') === concessionaria.id),
    error: status.getIn(['vigenciaTarifa', 'error']),
    isLoading: status.getIn(['vigenciaTarifa', 'isLoading']) || status.getIn(['subgrupo', 'isLoading']),
    sortColumn,
    sortDirection,
    multipleSubgrupo: subgrupo,
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...flashMessageAcionCreators,
    ...vigenciaTarifaActionCreators,
    ...subgrupoActionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VigenciaTarifaContainer))
